import { courseAttendanceApi, toLocalIsoDate } from "api/courseAttendanceApi";
import { QUERIES_KEYS } from "queries";
import { useQuery } from "@tanstack/react-query";

export const useCourseAttendanceDays = (courseId: string | number) => {
  const { isLoading, data } = useQuery({
    queryKey: QUERIES_KEYS.COURSE_ATTENDANCE_DAYS(courseId),
    queryFn: () => courseAttendanceApi.fetchDays(Number(courseId)),
  });

  return { isLoading, days: data?.data ?? [] };
};

export const useCourseAttendance = (courseId: string | number, day: Date | null) => {
  const { isLoading, isFetching, data } = useQuery({
    queryKey: QUERIES_KEYS.COURSE_ATTENDANCE(courseId, day ? toLocalIsoDate(day) : ""),
    queryFn: () => courseAttendanceApi.fetch(Number(courseId), day!),
    enabled: !!day,
  });

  return { isLoading, isFetching, attendance: data?.data };
};
